import { DateTime as p } from "luxon";
import { centsToDollar as E } from "./currency.js";
import { t as S } from "./toTitleCase-DdbgdWdW.js";
const m = (t) => {
  var e;
  return typeof t == "string" || typeof t == "number" ? t.toString() : Array.isArray(t) ? t.join(", ") : ((e = t == null ? void 0 : t.values) == null ? void 0 : e.join(", ")) || "";
}, F = /* @__PURE__ */ new Map([
  ["address", (t) => t],
  ["boolean", (t) => t],
  ["checkbox", (t) => t],
  [
    "date",
    (t) => p.fromISO(t).toFormat("MMMM d y")
  ],
  [
    "datetime",
    (t) => p.fromISO(t).toFormat("MMMM d y, h:mm a")
  ],
  ["dollar", (t) => E(t)],
  ["dropdown", (t) => m(t)],
  ["email", (t) => t],
  ["multiselect", (t) => m(t)],
  ["phonenumber", (t) => t],
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  ["number", (t) => t.toLocaleString()],
  ["textarea", (t) => t],
  ["textfield", (t) => t]
]), k = (t, e, n = ": ") => Object.entries(t).filter(([, a]) => !!a).map(([a, o]) => {
  const u = S(a), r = e == null ? void 0 : e.find((g) => g.name === a);
  if (!(r != null && r.type))
    return `${u}${n}${o}`;
  const f = F.get(r == null ? void 0 : r.type);
  return `${u}${n}${f ? f(o) : o}`;
});
function R(t) {
  return typeof t == "object" && t !== null && "message" in t && typeof t.message == "string";
}
function A(t) {
  if (!(typeof t == "object" && t !== null && "response" in t)) return !1;
  const { response: n } = t;
  if (!(typeof n == "object" && n !== null && "data" in n)) return !1;
  const { data: o } = n;
  return o ? typeof o.error == "string" : !1;
}
const M = (t) => typeof t == "string";
function N(t) {
  if (M(t)) return { message: t };
  if (A(t)) return { message: t.response.data.error };
  if (R(t)) return t;
  try {
    return new Error(JSON.stringify(t));
  } catch {
    return new Error(String(t));
  }
}
function q(t, e) {
  return t ? N(t).message : e ?? "An error occurred";
}
const c = window.ReactNativeWebView, i = (t) => {
  try {
    c && c.postMessage(t);
  } catch {
  }
}, h = (t, e) => {
  try {
    i(JSON.stringify({ action: t, ...e }));
  } catch {
  }
}, D = (t) => {
  h("hapticFeedback", { feedback: t });
};
function _(t) {
  try {
    i(t);
  } catch {
  }
}
function b(t) {
  try {
    i(JSON.stringify({ url: t, action: "URL.open" }));
  } catch {
  }
}
function y(t) {
  try {
    i(JSON.stringify({ url: t, action: "ShareURL" }));
  } catch {
  }
}
const $ = () => !!c, C = (t) => {
  try {
    i(JSON.stringify({ url: t, action: "navigate" }));
  } catch {
  }
};
var l;
const O = (l = window == null ? void 0 : window.nativeApp) == null ? void 0 : l.appVersion;
var d;
const T = ((d = window == null ? void 0 : window.nativeApp) == null ? void 0 : d.contactSeller) ?? !1, s = () => {
};
s.postAction = h;
s.postMessage = _;
s.postURL = b;
s.postShareURL = y;
s.hasWebView = $;
s.WebView = c;
s.haptic = D;
s.appVersion = O;
s.hasContactSeller = T;
s.navigateTo = C;
const w = /^[\sa-zA-Z0-9-.,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{1,50}$/, G = /^[\sa-zA-Z0-9-.,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{1,50}$/, I = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/, X = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/, L = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/, U = /^[\sa-zA-Z0-9-().,'\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,50}$/, V = /^[\sa-zA-Z0-9/-:().,#;'°&\u00C0-\u00FF\u0100-\u017F\u0180-\u024F]{2,100}$/, Z = /^(?![-]+$)[\sa-zA-Z0-9-]{2,16}$/, P = /^US$/, z = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/, v = {
  FIRST_NAME: w,
  LAST_NAME: G,
  ADDRESS1: X,
  ADDRESS2: L,
  CITY: U,
  STATE: V,
  ZIP_CODE: Z,
  DOB: z,
  US_ONLY_REGEX: P,
  PHONE_NUMBER_REGEX: I
}, H = {
  paypal: { name: "PayPal" },
  venmo: { name: "Venmo" },
  bank: { name: "Bank Account" }
}, W = (t) => !!t.trim().length;
function j(t) {
  return t.split("-").join("");
}
const J = (t) => {
  let e = "";
  const n = j(t);
  return W(n.trim()) ? /^[0-9]+(-[0-9]+)*$/.test(n.trim()) ? n.length > 12 ? e = "* phone number must be less than 12 digits" : n.length < 10 && (e = "* phone number must be 10 digits") : e = "* phone number should only contain numbers" : e = "* phone number is required", e;
}, K = {
  phoneNumber: J
};
export {
  s as Native,
  H as PAYMENT_ACCOUNTS_DICTIONARY,
  v as REGEX,
  K as Validator,
  q as getErrorMessage,
  k as toCustomFieldArray
};
